// removed by extract-text-webpack-plugin
module.exports = {"ba-display":"magazines_1P3VV","hover":"magazines_2CbyW","ba-img":"magazines_2dW4L","ba-absolute":"magazines_1LHr8","ba-title":"magazines_YeXjg","ba-subtitle":"magazines_Wz5iu","ba-relative":"magazines_2AuM0","ba-mg-0":"magazines_2Y2Nl"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/components/MagazineCard/styles.scss
// module id = 1032
// module chunks = 1